import { IconButton } from '../../../lib/button'
import { FaEraser, FaEdit } from 'react-icons/fa'

export const Cols = (onRowClickedDelete, Ekipmanlar) => {
  return [
    {
      name: 'Ekipman',
      selector: 'id',
      sortable: true,
      cell: row => (
        <div style={{ fontSize: 14 }}>
          {Ekipmanlar?.find(aa => aa.value == row.id)?.text}
        </div>
      )
    },

    {
      name: '',
      selector: 'delete',
      sortable: true,
      width: '90px',
      cell: row => (
        <IconButton
          icon={<FaEraser size={30} />}
          onClick={() => onRowClickedDelete(row.uuid)}
        // disabled={row.users_id < 1000 ? true : false}
        />
      )
    }
  ]
}
